import { Button, Card, Content, Form, Heading, Level, Media, Modal, Panel } from 'react-bulma-components';
import { MODAL_TYPES, useGlobalModalContext } from "../hooks/globalModal";
import React, { useEffect, useRef, useState } from 'react';
import { faMusic, faTrash } from '@fortawesome/free-solid-svg-icons';
import { gql, useMutation, useQuery } from '@apollo/client';

import Confirm from './confirm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Image from './image';
import { Loader } from '.';
import Player from './Player/Player';
import { faImage } from '@fortawesome/free-regular-svg-icons';
import { filesize } from "filesize";
import { useSnackbar } from 'react-simple-snackbar';

const { Checkbox } = Form;

export const GET_MEDIA = gql`
  query GetMedia2($path: String!) {
   mediaForPage(path: $path){
     id
     filename
     length
     uploadDate
   }
  }
`;
const DELETE_MEDIA = gql`
  mutation DeleteMedia($path: String!) {
    deleteMedia(path: $path){
     success
     message
     media {
      id
     }
   }
  }
`;

const MediaModal = ({ }) => {
  const pathRef = useRef(null);
  const [openSnackbar] = useSnackbar();
  const [bg, setBg] = useState(false);
  function handleBgChange(event) {
    setBg(event.target.checked ? true : false);
  }
  const [selectedFile, setSelectedFile] = useState();
  const [reloadToken, setReloadToken] = useState(0);
  function handleFileSelect(filename) {
    setBg(false);
    setSelectedFile(filename);
    setReloadToken(t => t + 1);   // ← tvingar Player att ladda om
  }
  const { hideModal, showModal, store } = useGlobalModalContext();
  const { modalProps } = store || {};
  const { title, path, confirmBtn, createModalFunction } = modalProps || {};
  const [showConfirm, setShowConfirm] = useState(false);
  const [editorOpen, setEditorOpen] = useState(false);

  useEffect(() => {
    if (!pathRef.current) return;
    pathRef.current.addEventListener('click', () => {
      if (document.selection) {
        const range = document.body.createTextRange();
        range.moveToElementText(pathRef.current);
        range.select();
      } else if (window.getSelection) {
        const range = document.createRange();
        range.selectNode(pathRef.current);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    })
  }, [pathRef.current]);

  const { data, loading, error, refetch } = useQuery(
    GET_MEDIA,
    {
      variables: { path: path },
      fetchPolicy: "cache-and-network"
    }
  );
  const [deleteFile, { loading: mutationDeleteLoading, error: mutationDeleteError }] = useMutation(DELETE_MEDIA,
    {
      onError(error) {
        console.log("error " + error);
        openSnackbar(error, 2000);
      },
      onCompleted(data) {
        setSelectedFile(null);
        refetch();
      }
    });

  const handleDeleteFile = () => {
    /* deleteFile({
      variables:
      {
        path: selectedFile
      },
      update: (cache, { data: { deleteMedia }}) => {
        if(deleteMedia.success){
          cache.evict({
            id: cache.identify(deleteMedia.media)
          });
          cache.gc();
        }
      }
    }) */
  }

  /*   const handleInsertImage = () => {
      returnImageProps({ path: selectedFile, bg: bg });
    } */

  const handleModalToggle = () => {
    hideModal();
  };

  const handleUploadModal = () => {
    showModal(MODAL_TYPES.MEDIA_UPLOAD_MODAL, {
      title: `Upload files`,
      confirmBtn: "Upload",
      path: path,
      createPreviousModalFunction: createModalFunction
    });
  }

  const handleDelete = () => {
    setShowConfirm(true);
  };

  const handleCancel = () => {
    setShowConfirm(false);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    deleteFile({
      variables:
      {
        path: selectedFile
      },
      update: (cache, { data: { deleteMedia }}) => {
        if(deleteMedia.success){
          cache.evict({
            id: cache.identify(deleteMedia.media)
          });
          cache.gc();
        }
      }
    })
  };

  if (error) return <p>ERROR {error.message}</p>;
  if (loading) return (
    <Loader />
  );
  return (
    <Modal show={true}
      onClose={handleModalToggle} className='modal-full-screen'>
      <Modal.Card style={{ width: '100%', height: '100%' }}>
        <Modal.Card.Header showClose={true}>
          <Modal.Card.Title>
            {title || "Create Modal"}
          </Modal.Card.Title>
        </Modal.Card.Header>
        <Modal.Card.Body>
          <Panel>
            {data.mediaForPage && data.mediaForPage.map((file, index) =>
              <Panel.Block
                key={index}
                renderAs="div"
                className="is-clickable panel-block-hover"
                active={file.filename === selectedFile}
                onClick={() => handleFileSelect(file.filename)}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >

                {/* Vänster del */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <Panel.Icon>
                    <FontAwesomeIcon
                      icon={file.filename.endsWith('mid') ? faMusic : faImage}
                    />
                  </Panel.Icon>

                  <span>{file.filename}</span>
                  <span style={{ color: '#999' }}>{filesize(file.length)}</span>
                  <span style={{ color: '#999' }}>{new Date(file.uploadDate).toLocaleString()}</span>
                </div>

                {/* Höger del: Delete-knapp */}
                {file.filename === selectedFile && (
                <FontAwesomeIcon
                  icon={faTrash}
                  style={{ color: '#7a7a7a'}}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete(file.filename);
                  }}
                />
                )}
              </Panel.Block>
            )}
          </Panel>

          <p><b><span ref={pathRef} style={{ cursor: 'pointer' }}>{selectedFile}</span></b></p>
          {selectedFile &&
            <>
              {selectedFile.endsWith('mid') ?
                <Player 
                  playerId="previewPlayer"
                  midiUrl={selectedFile} 
                  midiEditor={true} 
                  onSaved={() => refetch()} 
                  reloadToken={reloadToken}
                  editorOpen={editorOpen}
                  setEditorOpen={setEditorOpen} />
                :
                <Image src={selectedFile} bg={bg ? 'o' : ''} />
              }
              <Level>
                <Level.Side>
                  <Level.Item>
                    {!selectedFile.endsWith('mid') &&
                      <Checkbox name="bg" onChange={handleBgChange} checked={bg}>&nbsp;Background</Checkbox>
                    }
                  </Level.Item>
                </Level.Side>
{/*                 <Level.Side align="right">
                  <Level.Item>
                    <Button size={'small'} color="danger" type="button" onClick={handleDeleteFile}>Delete</Button>
                    <Button size={'small'} color="danger" type="button" onClick={handleDelete}>
                      Delete item
                    </Button>

                    <Confirm
                      show={showConfirm}
                      title="Are you sure?"
                      message="This action cannot be undone."
                      onCancel={handleCancel}
                      onConfirm={handleConfirm}
                    />
                  </Level.Item>
                </Level.Side> */}
              </Level>
            </>
          }
        <Confirm
                      show={showConfirm}
                      title="Are you sure?"
                      message="This action cannot be undone."
                      onCancel={handleCancel}
                      onConfirm={handleConfirm}
                    />
        </Modal.Card.Body>
        <Modal.Card.Footer style={{ alignItems: 'center', justifyContent: 'center' }}>
          <Button onClick={handleModalToggle}>Close</Button>
          <Button onClick={handleUploadModal}>Upload</Button>
          {/* <Button disabled={!selectedFile} onClick={handleInsertImage}>&lt;image /&gt;</Button> */}
        </Modal.Card.Footer>
      </Modal.Card>

    </Modal>
  )
}

export default MediaModal;